// Label dictionary: labels are stored in English ("bike lane") and shown in the reader's language.
// The dictionary lives in locales/<lang>/labels.json (keys are the English label with "_" for spaces).
// The backend asks the AI for labels from the same English list (smoothride_service/label_vocabulary.json).
import i18n from '@/i18n';

export const labelSlug = (text) => String(text || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');

// Display text: the dictionary entry in the current language, else the label as it was typed.
export function localizeLabel(text) {
  const { te, t } = i18n.global;
  const key = 'labels.' + labelSlug(text);
  return te(key) ? t(key) : text;
}

// Typed text -> English label. "Fahrrad" and "bicycle" both give "bicycle"; unknown text stays as typed.
export function canonicalLabel(text) {
  const wanted = String(text || '').trim().toLowerCase();
  if (!wanted) return '';
  for (const lang of ['en', 'de']) {
    const dict = (i18n.global.getLocaleMessage(lang) || {}).labels || {};
    for (const [slug, name] of Object.entries(dict)) {
      if (String(name).toLowerCase() === wanted || slug.replace(/_/g, ' ') === wanted) return slug.replace(/_/g, ' ');
    }
  }
  return String(text).trim();
}
